module.exports = __webpack_public_path__ + "cb121da18518688ccb396068700b6abd.MP3";